import React, { useState } from "react";
import PropTypes from "prop-types";
import { TextInput, Toggle } from "@opendate-app/setlist";
import { maxTicketsError } from "../../../shared/maxTicketsError";

const checkedFrom = (value) =>
  value && value.target ? value.target.checked : Boolean(value);

const SettingsTab = ({ settings, canEnableCheckoutCaptcha, onChange }) => {
  const [limitEdited, setLimitEdited] = useState(false);

  return (
    <div className="series-tab-panel">
      <section className="series-tab-section">
        <div style={{ maxWidth: "360px" }}>
          <TextInput
            id="series-max-tickets-per-email"
            label="Maximum Tickets Allowed"
            hint="Define the maximum number of tickets that can be purchased by a fan across multiple orders. If a fan attempts to purchase more than the maximum number of tickets allowed, they will receive an alert notifying them that the event has a maximum and the order will not process."
            size="sm"
            inputMode="numeric"
            placeholder="No limit"
            value={settings.maxTicketsPerEmail ?? ""}
            error={
              limitEdited ? maxTicketsError(settings.maxTicketsPerEmail) : null
            }
            onChange={(event) => {
              setLimitEdited(true);
              onChange({
                maxTicketsPerEmail: event.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 3),
              });
            }}
          />
        </div>
      </section>

      <section className="series-tab-section">
        <label className="series-edit-label" htmlFor="series-check-in-period">
          Check-in Period
        </label>
        <p className="series-edit-hint">
          Controls how ticket check-in counts are tracked. "All Time" counts
          every successful check-in against the scan limit. "Daily" resets the
          count each day at 4 AM venue local time.
        </p>
        <select
          id="series-check-in-period"
          className="series-edit-input series-tab-narrow-input"
          value={settings.checkInPeriod}
          onChange={(event) => onChange({ checkInPeriod: event.target.value })}
        >
          <option value="all_time">All Time</option>
          <option value="daily">Daily</option>
        </select>
      </section>

      {canEnableCheckoutCaptcha && (
        <section className="series-tab-section">
          <span className="series-edit-label">Checkout CAPTCHA</span>
          <p className="series-edit-hint">
            CAPTCHA verification protects your event from fraud and abuse.
            Opendate recommends enabling checkout CAPTCHA for high demand events
            to prevent bots from purchasing tickets. Verification is powered by
            Cloudflare Turnstile.
          </p>
          <Toggle
            id="series-checkout-captcha"
            label={
              settings.checkoutCaptchaEnabled
                ? "Checkout CAPTCHA Enabled"
                : "Checkout CAPTCHA Disabled"
            }
            checked={Boolean(settings.checkoutCaptchaEnabled)}
            onChange={(value) =>
              onChange({ checkoutCaptchaEnabled: checkedFrom(value) })
            }
          />
        </section>
      )}
    </div>
  );
};

SettingsTab.propTypes = {
  settings: PropTypes.object.isRequired,
  canEnableCheckoutCaptcha: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default SettingsTab;
